import { Action, Dispatch } from "redux";

let registeredDispatch: Dispatch<Action> | undefined;

export function registerReduxDispatch(dispatch: Dispatch<Action>) {
    registeredDispatch = dispatch;
}

export function getRegisteredDispatch(): Dispatch<Action> | undefined {
    return registeredDispatch;
}
